import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ErrorPage3 } from "./ErrorPage3";

export default function ErrorsPage() {
  return (
      <Routes>
        <Route path="/" element={<Navigate to="/error/error1" replace />} />
        <Route path="/error1" element={<ErrorPage3 />} />
      </Routes>
  );
}
